module.exports = __webpack_public_path__ + "static/NQF_Rating_Logo-d26cd837e68d778736f310b003f47a2a.png";